import { SEAT_MAP, TRAVEL_INSURANCE_INSIDE_EU, TRAVEL_INSURANCE_OUTSIDE_EU } from '@eti/products';
import { TRAVELER_DETAILS } from '../../../constants/formNamesConstants';

const isTravelInsuranceProduct = (id) =>
  [TRAVEL_INSURANCE_INSIDE_EU.id, TRAVEL_INSURANCE_OUTSIDE_EU.id].includes(id);

export const generateSeatMapProductComponent =
  (travelers, bounds) =>
  ({
    id,
    code,
    name,
    configuration,
    __typename,
    persuasion,
    isSelectable,
    productIncludedTexts,
    selectedWithTrip,
    sellSpecification,
    shouldShowPricePerBound,
    productPreSelection,
    productSpecificTexts,
  }) => {
    const order = {
      bounds,
      code,
      configuration,
      id,
      name,
      persuasion,
      productSpecificTexts,
      selectedWithTrip,
      sellSpecification,
      travelers,
      __typename,
    };

    const SeatMapComponent = SEAT_MAP.component;

    return {
      __typename: sellSpecification.__typename,
      id: Number(id),
      code,
      component: (
        <SeatMapComponent
          confirmation={{ isEnabled: isTravelInsuranceProduct(id) }}
          form={TRAVELER_DETAILS}
          isSelectable={isSelectable}
          order={order}
          productIncludedTexts={productIncludedTexts}
          productSpecificTexts={productSpecificTexts}
          sellSpecification={sellSpecification}
          shouldShowPricePerBound={shouldShowPricePerBound}
        />
      ),
      persuasion,
      productPreSelection,
      selectedWithTrip,
      sellSpecification,
    };
  };
